import useCheckRole from "Hooks/APICheckRole";
import React from "react";
import { Menu } from "semantic-ui-react";

type BillingMenuProps = {
  view: string;
  selectView: Function;
};

const BillingMenu = ({ selectView, view }: BillingMenuProps) => {
  const { hasRole, roles } = useCheckRole();
  return (
    <Menu fluid stackable pointing>
      <Menu.Item header>Billing</Menu.Item>
      {hasRole(roles.billing.rates.roles.view) && (
        <Menu.Item
          name='Rates'
          active={view === "rates"}
          onClick={() => selectView("rates")}
        />
      )}
      {hasRole(roles.billing.products.roles.view) && (
        <Menu.Item
          name='Products'
          active={view === "products"}
          onClick={() => selectView("products")}
        />
      )}
      {hasRole(roles.billing.codes.roles.view) && (
        <Menu.Item
          name='Codes'
          active={view === "codes"}
          onClick={() => selectView("codes")}
        />
      )}
    </Menu>
  );
};

export default BillingMenu;
